export default __webpack_public_path__ + "static/media/dachsberger-poster.90471e3f.png";